











































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { Location } from '@/modules/backend/Entities/Location';
import LocationDeleteButton from '@/components/locations/LocationDeleteButton.vue';
import LocationAddDialog from '@/components/locations/LocationAddDialog.vue';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { DataTableHeader } from 'vuetify';
import Mixin from '@/mixins/base';
import { LocationsModule } from '@/store/dashboard/locations/LocationsModule';
import { resolveModule } from '@/store';

@Component({
  mixins: [Mixin],
  components: {
    DataTableWrapper,
    'location-delete-button': LocationDeleteButton,
    'location-add-dialog': LocationAddDialog
  }
})
export default class LocationsTable extends Mixins(Mixin) {
  private readonly locationsModule: LocationsModule = resolveModule(LocationsModule);

  @Prop({ type: Boolean, default: false })
  private loading!: boolean;

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'id'
      },
      {
        text: this.$i18n.t('screens.locations.dialog_fields.name').toString(),
        value: 'name'
      },
      {
        text: this.$i18n.t('common.table.headers.actions').toString(),
        sortable: false,
        value: 'actions',
        align: 'end'
      }
    ];
  }

  get buildingId(): number {
    return Number(this.$route.params.buildingId);
  }

  get locationList(): Location[] {
    return this.locationsModule.LocationsByBuildingId(this.buildingId);
  }
}
